import styled, { css } from 'styled-components';

import { media } from '@savgroup-front-common/constants/shared/media';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../theme/helpers/fontStyle';

interface DropzoneProps {
  $isDragActive: boolean;
}

export const $FileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media ${media.minWidth.sm} {
    flex-direction: row;
  }
  justify-content: space-between;
  border: 1px solid ${(props) => props.theme.newUI.dividerColors.default};
  padding: ${spacing('xl')};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
`;

export const $FileInputLabelContainer = styled.div`
  flex: 1;
  padding-bottom: ${spacing('xl')};
  [class*='Labelstyles'] span {
    ${fontStyle('sm')}
    color: ${({ theme }) => theme.systemColors.defaultTextColor};
    font-weight: ${fontWeight('medium')};
    height: unset;
    margin: unset;
  }
  [class*='LabelWrap'] {
    height: unset;
  }
  label {
    height: unset;
  }
  @media ${media.minWidth.sm} {
    padding-right: ${spacing('xl')};
    padding-bottom: unset;
  }
`;

export const $FileInputDropZoneContainer = styled.div<{
  $shouldExpand: boolean;
}>`
  width: 100%;

  ${({ $shouldExpand }) =>
    $shouldExpand
      ? css`
          border-top: 1px solid
            ${(props) => props.theme.newUI.dividerColors.default};

          @media ${media.minWidth.sm} {
            border-top: unset;
            border-left: 1px solid
              ${(props) => props.theme.newUI.dividerColors.default};
            width: 223px;
          }
        `
      : undefined}
`;

export const $Didactics = styled.div`
  ${fontStyle('xs')};
  font-weight: ${fontWeight('normal')};
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: ${spacing('xl')};
`;

export const $FileInput = styled.input`
  display: none;
`;

export const $Dropzone = styled.button<DropzoneProps>`
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  background: transparent;
  border: none;
  padding-top: ${spacing('xl')};
  transition-duration: 0.3s;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};

  span:last-child {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
    cursor: pointer;
  }

  @media ${media.minWidth.sm} {
    padding-top: unset;
    padding-left: ${spacing('xl')};
    padding-right: unset;
  }

  & div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const $MinimalWrapper = styled.div`
  display: flex;
  gap: ${spacing('xxl')};

  &&& {
    flex-direction: row;
  }
`;
